module.exports = __webpack_public_path__ + "static/media/boat-img-12.b6f977bc.jpg";